module.exports = __webpack_public_path__ + "static/media/SunriseWallet.1e99b46e.png";